/* eAuto Bought Together — widget v5 (COUNT-TIERED per-item bundle discount).
   The % scales with how many add-ons are bundled (tiers from config); it is applied
   uniformly to every bundled line and bounded by a configurable cap (flat / percent /
   both). The nudge lures toward the ACCESSORY only; spares get soft, need-based copy.
   Mirrors the Shopify Function exactly. Nothing here is hardwired — all rates, the cap
   and the copy come from the shop `eauto.bundle_config` metafield via data attributes. */
(function () {
  var root = document.querySelector("[data-ebt]");
  if (!root) return;

  // A/B arms are CONFIG-DRIVEN (from shop bundle_config → data attributes), not hardwired.
  // disc = derived from the holdout %: none = holdout, complete_kit = the rest.
  function jparse(s) { try { return JSON.parse(s || "null"); } catch (e) { return null; } }
  function armsFromObj(o, dflt) {
    if (!o || typeof o !== "object") return dflt;
    var a = Object.keys(o).map(function (k) { return [k, parseFloat(o[k]) || 0]; }).filter(function (x) { return x[1] > 0; });
    return a.length ? a : dflt;
  }
  var holdout = parseFloat(root.getAttribute("data-ebt-holdout"));
  if (!(holdout >= 0 && holdout <= 100)) holdout = 10;
  var ARMS = {
    layout: armsFromObj(jparse(root.getAttribute("data-ebt-layout-arms")), [["two_modules", 50], ["blended", 50]]),
    disc: [["complete_kit", Math.max(1, 100 - holdout)], ["none", holdout]],
  };
  function cookieVid() {
    var m = document.cookie.match(/(?:^|;\s*)ebt_vid=([^;]+)/);
    if (m) return m[1];
    var id = (Date.now().toString(36) + Math.random().toString(36).slice(2, 8));
    document.cookie = "ebt_vid=" + id + ";path=/;max-age=" + 60 * 60 * 24 * 180;
    return id;
  }
  function hash(s) { var h = 0; for (var i = 0; i < s.length; i++) { h = (h * 31 + s.charCodeAt(i)) >>> 0; } return h; }
  function assign(salt, arms) {
    var b = hash(cookieVid() + salt) % 100, acc = 0;
    for (var i = 0; i < arms.length; i++) { acc += arms[i][1]; if (b < acc) return arms[i][0]; }
    return arms[arms.length - 1][0];
  }
  var layoutArm = assign("lyt", ARMS.layout);
  var discArm = assign("dsc", ARMS.disc);

  function jsonAttr(name) { try { return JSON.parse(root.getAttribute(name) || "null"); } catch (e) { return null; } }
  var cfg = {
    model: root.getAttribute("data-ebt-model") || "",
    current: parseInt(root.getAttribute("data-ebt-current-price"), 10) || 0,
    mainVariant: root.getAttribute("data-ebt-main-variant"),
    tiers: jsonAttr("data-ebt-tiers"),
    capMode: root.getAttribute("data-ebt-cap-mode") || "flat",
    capFlat: +root.getAttribute("data-ebt-cap-flat") || 0,
    capPct: +root.getAttribute("data-ebt-cap-pct") || 0,
    crossOn: root.getAttribute("data-ebt-cross-enabled") !== "false",
    discountLive: root.getAttribute("data-ebt-discount-live") === "true",
    sticky: root.getAttribute("data-ebt-sticky") === "true",
    cartReminder: root.getAttribute("data-ebt-cart-reminder") === "true",
  };
  var kitLabel = cfg.model ? (cfg.model + " kit") : "kit";

  var rows = Array.prototype.slice.call(root.querySelectorAll("[data-ebt-row]"));
  function money(p) { return "₹" + Math.round(p / 100).toLocaleString("en-IN"); }
  function gid(id) { return "gid://shopify/ProductVariant/" + id; }
  function price(r) { return parseInt(r.getAttribute("data-price"), 10) || 0; }
  function gidOf(r) { return gid(r.getAttribute("data-variant-id")); }
  function isOn(r) { return r.getAttribute("data-checked") === "true"; }
  function ofLever(lever, onlyChecked) {
    return rows.filter(function (r) {
      return r.getAttribute("data-lever") === lever && (!onlyChecked || isOn(r));
    });
  }
  function checkedAddons() { return rows.filter(function (r) { var l = r.getAttribute("data-lever"); return (l === "complementary" || l === "accessory") && isOn(r); }); }
  function sumP(list) { return list.reduce(function (s, r) { return s + price(r); }, 0); }

  // ── count -> %  (highest tier key <= count; beyond the top tier uses the top) ──
  function tierPct(n) {
    var t = cfg.tiers; if (!t || n <= 0) return 0;
    var chosen = 0, chosenK = -1, maxK = -1, maxV = 0;
    for (var k in t) { var kk = parseInt(k, 10); if (!isFinite(kk)) continue; var v = +t[k] || 0;
      if (kk > maxK) { maxK = kk; maxV = v; }
      if (kk <= n && kk > chosenK) { chosenK = kk; chosen = v; } }
    if (maxK >= 0 && n > maxK) return maxV;
    return chosenK >= 0 ? chosen : 0;
  }
  function capFor(bundleSub) {
    var flat = cfg.capFlat > 0 ? cfg.capFlat * 100 : 0;
    var pctCap = cfg.capPct > 0 ? cfg.capPct / 100 * bundleSub : 0;
    if (cfg.capMode === "percent") return pctCap;
    if (cfg.capMode === "both") { var v = [flat, pctCap].filter(function (x) { return x > 0; }); return v.length ? Math.min.apply(null, v) : 0; }
    return flat;
  }
  // effective % after the cap (uniform across the bundle), mirrors the Function
  function computed() {
    var out = { pct: 0, disc: 0, sub: 0, capped: false, n: 0 };
    if (discArm === "none" || !cfg.crossOn) return out;
    var addons = checkedAddons(); out.n = addons.length;
    if (!addons.length) return out;
    var sub = cfg.current + sumP(addons); out.sub = sub;
    if (sub <= 0) return out;
    var pct = tierPct(addons.length); if (pct <= 0) return out;
    var cap = capFor(sub);
    if (cap > 0 && pct / 100 * sub > cap) { pct = cap / sub * 100; out.capped = true; }
    out.pct = Math.round(pct * 100) / 100;
    out.disc = Math.round(out.pct / 100 * sub);
    return out;
  }

  // ── analytics → app proxy → Worker → D1 (best-effort, never blocks) ──
  function track(type) {
    try {
      var c = computed();
      fetch("/apps/fbt/event", {
        method: "POST", headers: { "Content-Type": "application/json" }, keepalive: true,
        body: JSON.stringify({
          type: type, product: cfg.mainVariant, addons: c.n, pct: c.pct,
          value: Math.round((cfg.current + sumP(checkedAddons())) / 100),
          disc: discArm, layout: layoutArm, session: cookieVid(),
        }),
      }).catch(function () {});
    } catch (e) {}
  }

  var rowsEl = root.querySelector("[data-ebt-rows]");
  function header(text) {
    var li = document.createElement("li");
    li.className = "ebt2__modhead"; li.setAttribute("role", "presentation"); li.textContent = text;
    return li;
  }
  if (layoutArm === "two_modules") {
    var fc = rowsEl.querySelector('[data-lever="complementary"]');
    var fa = rowsEl.querySelector('[data-lever="accessory"]');
    if (fc) rowsEl.insertBefore(header("Often replaced together"), fc);
    if (fa) rowsEl.insertBefore(header("Riders also add"), fa);
    root.classList.add("ebt2--modules");
  } else { root.classList.add("ebt2--blended"); }

  // ── savings ladder ──
  var rungs = Array.prototype.slice.call(root.querySelectorAll("[data-ebt-rung]"));
  var fillEl = root.querySelector("[data-ebt-fill]");
  var PAD = 8;
  function rungPos(i) { return rungs.length > 1 ? PAD + i * (100 - 2 * PAD) / (rungs.length - 1) : 50; }
  rungs.forEach(function (rg, i) { rg.style.left = rungPos(i) + "%"; });
  function renderLadder(n) {
    // Proportional progress: fills to 100% when the top available tier is reached (no grey tail).
    if (fillEl) fillEl.style.width = (n <= 0 ? 0 : Math.min(100, n / rungs.length * 100)) + "%";
    rungs.forEach(function (rg, i) { rg.setAttribute("data-reached", (i + 1) <= n ? "true" : "false"); });
  }

  // ── nudge: lure toward the ACCESSORY only; soft need-based copy for spares ──
  function renderNudge(n) {
    var nudge = root.querySelector("[data-ebt-nudge]");
    if (!nudge) return;
    var txt = nudge.querySelector("[data-ebt-nudge-text]");
    var maxTier = rungs.length;
    var accOff = ofLever("accessory", false).filter(function (r) { return !isOn(r); })[0];
    var spareOff = ofLever("complementary", false).filter(function (r) { return !isOn(r); })[0];
    if (!cfg.discountLive || (!accOff && !spareOff) || n >= maxTier) {
      if (n >= maxTier && n > 0 && cfg.discountLive) {
        nudge.hidden = false; nudge.setAttribute("data-tone", "done");
        txt.textContent = "You've unlocked the biggest saving — " + Math.round(tierPct(n)) + "% off your " + cfg.model + " kit.";
      } else { nudge.hidden = true; }
      return;
    }
    var next = tierPct(n + 1);
    nudge.hidden = false;
    if (accOff) {
      nudge.setAttribute("data-tone", "lure");
      var an = accOff.getAttribute("data-name") || "accessory";
      txt.textContent = (n === 0
        ? "Add the " + an + " and start saving " + Math.round(next) + "% on your " + cfg.model + " kit."
        : "You're one accessory away from " + Math.round(next) + "% — add the " + an + ".");
    } else {
      nudge.setAttribute("data-tone", "soft");
      var sn = spareOff.getAttribute("data-name") || "the next part";
      txt.textContent = "Doing the full job? Add the " + sn + " to reach " + Math.round(next) + "%.";
    }
  }

  function render() {
    var c = computed();
    var totalSave = 0;
    rows.forEach(function (r) {
      var lever = r.getAttribute("data-lever");
      var now = r.querySelector("[data-ebt-now]"), orig = r.querySelector("[data-ebt-orig]"), sv = r.querySelector("[data-ebt-save]");
      if (!now) return;
      var p = price(r);
      var included = lever === "current" || isOn(r);
      var saving = (cfg.discountLive && c.pct > 0 && included) ? Math.round(c.pct / 100 * p) : 0;
      if (saving > 0) {
        if (orig) { orig.hidden = false; orig.textContent = money(p); }
        now.textContent = money(p - saving);
        if (sv) { sv.hidden = false; sv.textContent = "Save " + money(saving); }
        totalSave += saving;
      } else {
        if (orig) orig.hidden = true;
        now.textContent = money(p);
        if (sv) sv.hidden = true;
      }
    });

    var banner = root.querySelector("[data-ebt-savebanner]");
    var big = root.querySelector("[data-ebt-savebig]"), sub = root.querySelector("[data-ebt-savesub]");
    if (banner) {
      if (cfg.discountLive && totalSave > 0) {
        banner.hidden = false;
        big.textContent = "You save " + money(totalSave);
        sub.textContent = c.capped
          ? (Math.round(c.pct) + "% off — maximum kit saving reached")
          : (Math.round(c.pct) + "% off every item in your " + kitLabel);
      } else banner.hidden = true;
    }

    var checkedRecs = checkedAddons();
    var original = cfg.current + sumP(checkedRecs);
    var os = root.querySelector("[data-ebt-original]"), fe = root.querySelector("[data-ebt-final]");
    if (os) os.textContent = totalSave > 0 ? money(original) : "";
    if (fe) fe.textContent = money(original - totalSave);
    var cnt = 1 + checkedRecs.length;
    var lbl = root.querySelector("[data-ebt-cta-label]");
    if (lbl) lbl.textContent = "Add " + cnt + (cnt === 1 ? " item" : " items") + " to cart" + (totalSave > 0 ? " · save " + money(totalSave) : "");
    if (sbLabel) sbLabel.textContent = (totalSave > 0 ? "Save " + money(totalSave) + " · " : "") + "Add " + cnt + (cnt === 1 ? " item" : " items");

    renderLadder(c.n);
    renderNudge(c.n);
  }

  function setAttrs() {
    var attrs = {
      _ebt_layout: layoutArm, _ebt_disc: discArm,
      _ebt_main: gid(cfg.mainVariant),
      _ebt_comp: ofLever("complementary", true).map(gidOf).join(","),
    };
    return fetch("/cart/update.js", {
      method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ attributes: attrs }),
    });
  }

  // toggle a row (row button or the quick-view add button share this)
  function toggleRow(r, forceOn) {
    var on = isOn(r);
    var next = typeof forceOn === "boolean" ? forceOn : !on;
    r.setAttribute("data-checked", next ? "true" : "false");
    r.classList.toggle("is-checked", next);
    var btn = r.querySelector("[data-ebt-toggle]");
    if (btn) btn.setAttribute("aria-pressed", next ? "true" : "false");
    var qadd = r.querySelector("[data-ebt-qadd]");
    if (qadd) { qadd.setAttribute("data-on", next ? "true" : "false"); qadd.textContent = next ? "In your kit" : (qadd.getAttribute("data-add-label") || "Add to kit"); }
    render(); setAttrs();
  }

  rows.forEach(function (r) {
    if (r.getAttribute("data-locked") === "true") return;
    var btn = r.querySelector("[data-ebt-toggle]");
    if (btn) btn.addEventListener("click", function () { toggleRow(r); });
    var qadd = r.querySelector("[data-ebt-qadd]");
    if (qadd) qadd.addEventListener("click", function () { toggleRow(r); });
  });

  // quick view — open/close inline, NEVER navigate away
  rows.forEach(function (r) {
    var q = r.querySelector("[data-ebt-ql]"), panel = r.querySelector("[data-ebt-qp]");
    if (!q || !panel) return;
    function toggle() { var open = !panel.hidden; panel.hidden = open; q.setAttribute("aria-expanded", open ? "false" : "true"); }
    q.addEventListener("click", toggle);
    var close = r.querySelector("[data-ebt-qclose]");
    if (close) close.addEventListener("click", function () { panel.hidden = true; q.setAttribute("aria-expanded", "false"); });
  });

  // Cart-drawer saving reminder (config-gated, theme-agnostic, fail-safe).
  function cartReminder(totalSave) {
    if (!cfg.cartReminder || !(totalSave > 0)) return;
    var text = "Your kit saving: " + money(totalSave) + " applied";
    var mo = new MutationObserver(function () {
      var drawer = document.querySelector(".cart-drawer.is-open,[data-cart-drawer].active,.drawer--cart.active,.cart-drawer--active,.cart-drawer,[data-cart-drawer]");
      if (drawer && !drawer.querySelector("[data-ebt-cartsave]")) {
        var d = document.createElement("div");
        d.className = "ebt2__cartsave"; d.setAttribute("data-ebt-cartsave", ""); d.textContent = text;
        drawer.insertBefore(d, drawer.firstChild); mo.disconnect();
      }
    });
    try { mo.observe(document.body, { childList: true, subtree: true }); setTimeout(function () { mo.disconnect(); }, 6000); } catch (e) {}
  }

  // Shared add flow — used by the main CTA and the mobile sticky bar.
  function addBundle() {
    var status = root.querySelector("[data-ebt-status]");
    var totalSave = computed().disc;
    var items = [];
    rows.forEach(function (r) {
      var lever = r.getAttribute("data-lever");
      if (lever === "current") { items.push({ id: +r.getAttribute("data-variant-id"), quantity: 1 }); return; }
      if (isOn(r)) items.push({ id: +r.getAttribute("data-variant-id"), quantity: 1 });
    });
    if (status) status.textContent = "Adding…";
    track("add");
    cartReminder(totalSave);
    // Write bundle attributes FIRST (awaited) so a redirect can't cancel them, THEN add items.
    Promise.resolve(setAttrs()).catch(function () {})
      .then(function () { return fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ items: items }) }); })
      .then(function (res) { if (!res.ok) throw new Error("add failed"); return res; })
      .then(function () {
        if (status) status.textContent = "Added to cart";
        document.dispatchEvent(new CustomEvent("cart:refresh"));
        document.dispatchEvent(new CustomEvent("cart:open"));
        setTimeout(function () {
          var drawerOpen = document.querySelector(".cart-drawer.is-open,[data-cart-drawer].active,.drawer--cart.active,.cart-drawer--active");
          if (!drawerOpen) window.location.href = "/cart";   // reminder injects into the drawer only if one opens
        }, 350);
      })
      .catch(function () { if (status) status.textContent = "Could not add — please try again."; });
  }
  root.querySelector("[data-ebt-add]").addEventListener("click", addBundle);

  // Mobile sticky add-bar (config-gated) — mirrors the CTA; shows on small screens when the CTA scrolls off.
  var sticky = document.querySelector("[data-ebt-stickybar]");
  var sbAdd = document.querySelector("[data-ebt-sb-add]");
  var sbLabel = document.querySelector("[data-ebt-sb-label]");
  if (sticky && sbAdd) {
    sbAdd.addEventListener("click", addBundle);
    var ctaVisible = true;
    var syncSticky = function () { sticky.style.display = (cfg.sticky && window.innerWidth <= 600 && !ctaVisible) ? "flex" : "none"; };
    try { new IntersectionObserver(function (es) { ctaVisible = es[0].isIntersecting; syncSticky(); }, { threshold: 0 }).observe(root.querySelector("[data-ebt-add]")); } catch (e) {}
    window.addEventListener("resize", syncSticky);
  }

  setAttrs(); render(); track("impression");
})();
